import React, {useEffect, useState} from "react";
import {Title} from "../../../components/components";
import {useGetCmpAppsQuery,} from "../../../api/cmpApiSlice";
import {useHistory, useParams} from "react-router-dom";
import {useGetPublisherQuery} from "../../../api/publisherApiSlice";
import CmpApps from "../../../components/cmp/CmpApps";
import {CmpPreview} from "../../../components/cmp/CmpPreview";
import usePublisherCmpConfiguration from "../../api_hooks/usePublisherCmpConfiguration";
import CmpConfiguration from "../../../components/cmp/CmpConfiguration";
import {useCreateAppGroupMutation} from "../../../api/appGroupApiSlice";

export default function CmpPublisherConfiguration(props) {
  const {publisherId} = useParams();
  const history = useHistory();
  const params = {configurableType: 'publisher', configurableId: publisherId}

  const {data: publisher = {}, isPublisherSuccess} = useGetPublisherQuery({publisherId})
  const {data: apps = {}, isSuccess: isAppsSuccess} = useGetCmpAppsQuery(params)
  const {cmpPreviewProps, cmpConfigurationProps} = usePublisherCmpConfiguration(params)
  const [createAppGroup] = useCreateAppGroupMutation()

  return (
    <>
      <Title main={publisher.name} sub="CMP Configuration" onBack={()=>(history.push(`/publishers/${publisherId}`))}/>
      <CmpConfiguration {...cmpConfigurationProps}>
        <CmpApps
          icon={"app"}
          as={"cmp.apps"}
          apps={apps}
          setAppPreviewId={cmpPreviewProps.setAppPreviewId}
          createAppGroup={createAppGroup}
          publisherId={publisherId}/>
      </CmpConfiguration>
      <CmpPreview {...cmpPreviewProps} />
    </>
  )
}
